var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-3" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.settleProof.buyerRealComName || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.settleProof.sellerRealComName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.settleProof.buyerInnerSellerCode || ""))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settleProof.memo,
                expression: "settleProof.memo"
              }
            ],
            staticStyle: { width: "320px", height: "90px" },
            domProps: { value: _vm.settleProof.memo },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.settleProof, "memo", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("验收单信息")]),
      _vm._v(" "),
      _vm.receiptList != null && _vm.receiptList.length > 0
        ? _c("div", { staticClass: "fr" }, [
            _c("span", [
              _vm._v("验收单数量：" + _vm._s(_vm.receiptList.length || 0))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "ml5" }, [
              _vm._v(
                "结算金额：" +
                  _vm._s(parseFloat(_vm.amount || 0).toFixed(2)) +
                  "元"
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-layout" }, [
      _vm.receiptList != null && _vm.receiptList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.receiptList,
                    border: "",
                    "tooltip-effect": "dark",
                    maxHeight: "400"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "innerNo",
                      label: "验收单号",
                      width: "200",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "costCenterCode",
                      label: "成本中心",
                      width: "140",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "buyerBizUnitName",
                      label: "所属业务单元",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "createTime",
                      label: "创建时间",
                      width: "140"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "contractNo",
                      label: "系统合同编号",
                      width: "140",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ntxAmount",
                      align: "right",
                      width: "150",
                      label: "未税金额(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s((rows.row.ntxAmount || 0).toFixed(2))
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taxAmount",
                      align: "right",
                      width: "150",
                      label: "税额(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s((rows.row.taxAmount || 0).toFixed(2))
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taxRate",
                      align: "right",
                      width: "150",
                      label: "税率(%)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.taxRate != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.taxRate.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wtxAmount",
                      align: "right",
                      width: "150",
                      label: "含税金额(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.wtxAmount != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.wtxAmount.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "violateState",
                      label: "违约状态"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.violated && rows.row.violateState == 1
                              ? _c("span", { staticClass: "font-red" }, [
                                  _vm._v("违约（未处理）")
                                ])
                              : rows.row.violated && rows.row.violateState == 0
                              ? _c("span", { staticClass: "font-green" }, [
                                  _vm._v("违约（已处理）")
                                ])
                              : !rows.row.violated
                              ? _c("span", [_vm._v("正常")])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算描述")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4992839e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4992839e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/ServcWorkSettleProofSave.vue
// module id = 3019
// module chunks = 0